import { CommonModule } from '@angular/common';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { AlertModule } from 'ngx-bootstrap/alert';
import { Routes, RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedUIModule } from '../shared/shared-ui.module';
import { GDPRService } from 'src/app/core/services/rulebook';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SelfAssessmentComponent } from './self-assessment.component';
import { CommonService } from './../../core/services/common/common.service';
import { SessionService } from 'src/app/core/services/auth/session.service';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { AssessmentDetailsComponent } from './assessment-details/assessment-details.component';
import { SelfAssessmentGapComponent } from './self-assessment-gap/self-assessment-gap.component';
import { SelfAssessmentDialogComponent } from './self-assessment-dialog/self-assessment-dialog.component';
import { SelfAssessmentSummaryComponent } from './self-assessment-summary/self-assessment-summary.component';
import { SelfAssessmentDashboardComponent } from './self-assessment-dashboard/self-assessment-dashboard.component';
import { SelfAssessmentEnhancementComponent } from './self-assessment-enhancement/self-assessment-enhancement.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatExpansionModule } from '@angular/material/expansion';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BulkSelfUpdateDialogComponent } from './bulk-self-update-dialog/bulk-self-update-dialog.component';
import { SelfAssessmentModalDialogComponent } from './self-assessment-modal-dialog/self-assessment-modal-dialog.component';
import { SelfAssessmentTemplate2Module } from '../self-assessment-template2/self-assessment-template2.module';
import { SelfAssessmentT3SummaryComponent } from './self-assessment-t3-summary/self-assessment-t3-summary.component';
import { SelfAssessmentTemplate3Module } from '../self-assessment-template3/self-assessment-template3.module';
import { LucideAngularModule, Upload,File, Plus, Save } from 'lucide-angular';
import { SelfAssessmentDashboard2Component } from './self-assessment-dashboard2/self-assessment-dashboard2.component';
import { selfAssessmentRoutes } from './self-assessment.routes';
import { SelfAssessmentDashboard3Component } from './self-assessment-dashboard3/self-assessment-dashboard3.component';


@NgModule({
  declarations: [
    SelfAssessmentComponent,
    AssessmentDetailsComponent,
    SelfAssessmentSummaryComponent,
    SelfAssessmentGapComponent,
    SelfAssessmentDialogComponent,
    SelfAssessmentDashboardComponent,
    SelfAssessmentEnhancementComponent,
    BulkSelfUpdateDialogComponent,
    SelfAssessmentModalDialogComponent,
    SelfAssessmentT3SummaryComponent,
    SelfAssessmentDashboard2Component,
    SelfAssessmentDashboard3Component,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    //RouterModule.forChild(routes),
    RouterModule.forChild(selfAssessmentRoutes),
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    DistributedUIModule,
    MatChipsModule,
    BsDropdownModule,
    SharedUIModule,
    ScrollingModule,
    NgxPowerBiModule,
    AngularEditorModule,
    MatExpansionModule,
    CKEditorModule,
    SelfAssessmentTemplate2Module,
    SelfAssessmentTemplate3Module,
    LucideAngularModule.pick({Upload, File, Plus, Save})
  ],
  providers: [GDPRService, AnalyticsService, SessionService, CommonService],
  entryComponents: [SelfAssessmentDialogComponent,BulkSelfUpdateDialogComponent,SelfAssessmentModalDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SelfAssessmentModule {}
